var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.251 2.49805C19.0811 2.49799 19.8798 2.8156 20.4832 3.38572C21.0866 3.95584 21.449 4.73524 21.496 5.56405L21.501 5.74805V17.752C21.501 18.614 21.1586 19.4407 20.5491 20.0501C19.9396 20.6596 19.113 21.002 18.251 21.002H6.251C5.42069 21.0024 4.62175 20.6849 4.01813 20.1147C3.41452 19.5446 3.05201 18.765 3.005 17.936L3 17.752V5.74805C3 4.88609 3.34241 4.05944 3.9519 3.44995C4.5614 2.84046 5.38805 2.49805 6.25 2.49805H18.251ZM11.5 9.49805L4.5 9.49905V17.752L4.507 17.912C4.54691 18.3467 4.74781 18.7508 5.07028 19.0449C5.39275 19.3391 5.81351 19.5021 6.25 19.502L11.5 19.501V9.49805ZM20 15.498L13 15.499V19.501H18.25C18.7141 19.501 19.1592 19.3167 19.4874 18.9885C19.8156 18.6603 20 18.2152 20 17.751V15.498ZM18.251 3.99805L13 3.99705V14L20 13.999L20.001 5.74905L19.994 5.58905C19.9541 5.15439 19.7532 4.75033 19.4307 4.45617C19.1082 4.162 18.6875 3.99896 18.251 3.99905V3.99805ZM11.5 3.99705L6.25 3.99805L6.107 4.00405C5.6693 4.04019 5.26119 4.23958 4.96368 4.56266C4.66617 4.88573 4.50102 5.30886 4.501 5.74805L4.5 8.00005H11.5V3.99605V3.99705Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.e2887c0f82a051d8210a8d07d8e41cd6.svg";
export { ForwardRef as ReactComponent };